<a
    (click)="$event.stopPropagation()"
    href="tel:{{ contactPhonenumber }}"
    class="pill pill--telephone">
    <i class="uil uil-phone"></i>
    {{ contactPhonenumber }}
</a>
